module.exports = __webpack_public_path__ + "img/tab-sand-tank.51afde92.png";